// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Atom_Box from "../../atom/Atom_Box.bs.js";
import * as Atom_Cta from "../../atom/Atom_Cta.bs.js";
import * as Util_Dom from "../../../util/Util_Dom.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Particle_Css from "../../particle/Particle_Css.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";
import * as Type_Organism_Menu from "../../../type/Type_Organism_Menu.bs.js";
import * as Organism_Menu_Brand from "./Organism_Menu_Brand.bs.js";
import * as UseScreenResolution from "../../../hook/UseScreenResolution.bs.js";
import * as Organism_Menu_Items_Utils from "./Organism_Menu_Items_Utils.bs.js";
import * as Organism_Menu_Item_With_Childs from "./Organism_Menu_Item_With_Childs.bs.js";

function Organism_Menu_Items$Link(Props) {
  var ariaLabel = Props.ariaLabel;
  var id = Props.id;
  var label = Props.label;
  var href = Props.href;
  var subLinks = Props.subLinks;
  var title = Props.title;
  var highlight = Props.highlight;
  var isCurrent = Props.isCurrent;
  var view = Props.view;
  var ctaHighlightStyle = view.ctaHighlightStyle;
  var ctaStyle = view.ctaStyle;
  var style = highlight ? (
      ctaHighlightStyle !== undefined ? ctaHighlightStyle : Curry._1(ctaStyle, /* Default */1)
    ) : (
      isCurrent !== undefined && isCurrent ? Curry._1(ctaStyle, /* Current */0) : Curry._1(ctaStyle, /* Default */1)
    );
  if (subLinks !== undefined) {
    var tmp = {
      id: id,
      label: label,
      subLinks: subLinks,
      highlight: highlight,
      view: view
    };
    if (ariaLabel !== undefined) {
      tmp.ariaLabel = Caml_option.valFromOption(ariaLabel);
    }
    return React.createElement(Organism_Menu_Item_With_Childs.make, tmp);
  }
  if (href === undefined) {
    return null;
  }
  var tmp$1 = {
    href: href,
    label: label,
    style: style
  };
  if (title !== undefined) {
    tmp$1.title = title;
  }
  return React.createElement(Atom_Box.make, {
              children: React.createElement(Atom_Cta.Link.make, tmp$1),
              id: id,
              kind: /* ItemList */4,
              key: id
            });
}

var Link = {
  make: Organism_Menu_Items$Link
};

function Organism_Menu_Items(Props) {
  var links = Props.links;
  var view = Props.view;
  var currentLinkId = Props.currentLinkId;
  var buttonMore = Props.buttonMore;
  var refRoot = Props.refRoot;
  var children = Props.children;
  var searchButtonId = Props.searchButtonId;
  var ctaStyle = view.ctaStyle;
  var direction = Particle_Screen_Ds.make(undefined, undefined, "row", undefined, undefined, "column");
  var width = Particle_Screen_Ds.make(undefined, undefined, "auto", undefined, undefined, {
        NAME: "percent",
        VAL: 100
      });
  var linksVisibleDefault = React.useMemo((function () {
          return Belt_Array.map(links, (function (link) {
                        return Type_Organism_Menu.linkToInternalLink(link, Organism_Menu_Items_Utils.approxItemWidth(link.label, ctaStyle));
                      }));
        }), [links]);
  var match = React.useState(function () {
        return linksVisibleDefault;
      });
  var setLinksVisible = match[1];
  var linksVisible = match[0];
  var match$1 = React.useState(function () {
        return [];
      });
  var setLinksMore = match$1[1];
  var linksMore = match$1[0];
  var match$2 = React.useState(function () {
        return 0;
      });
  var setLastWidthAvailable = match$2[1];
  var lastWidthAvailable = match$2[0];
  var refItems = React.useRef(null);
  UseScreenResolution.make(undefined, (function (screenSize) {
          var linksWithWidth = Belt_Array.map(linksVisible, (function (link) {
                  var width = Organism_Menu_Items_Utils.getWidthForId(Util_Dom.getDomRef(refItems), link.id);
                  return Type_Organism_Menu.Internal.updateLinkWidth(link, width);
                }));
          var variant = screenSize.NAME;
          if (variant === "XS" || variant === "S") {
            var screenSize$1 = screenSize.VAL;
            Curry._1(setLinksVisible, (function (oldLinksVisible) {
                    return Belt_Array.concat(oldLinksVisible, linksMore);
                  }));
            Curry._1(setLinksMore, (function (param) {
                    return [];
                  }));
            return Curry._1(setLastWidthAvailable, (function (param) {
                          return screenSize$1;
                        }));
          }
          var screenSize$2 = screenSize.VAL;
          var widths_brand = Organism_Menu_Items_Utils.getWidthForId(Util_Dom.getDomRef(refRoot), Organism_Menu_Brand.id);
          var widths_buttonMore = Organism_Menu_Items_Utils.getWidthForId(Util_Dom.getDomRef(refRoot), buttonMore.id);
          var widths_buttonSearch = Belt_Option.getWithDefault(Belt_Option.map(searchButtonId, (function (id) {
                      return Organism_Menu_Items_Utils.getWidthForId(Util_Dom.getDomRef(refRoot), id);
                    })), 0);
          var widthAvailable = ((screenSize$2 - widths_buttonSearch | 0) - widths_brand | 0) - widths_buttonMore | 0;
          var match = Util_Dom.getElementSize(Util_Dom.getDomRef(refItems));
          var widthListItems = match.width | 0;
          var isMobile = lastWidthAvailable < Particle_Css.breakpoint("M");
          var match$1 = lastWidthAvailable < screenSize$2;
          var match$2;
          var exit = 0;
          if (match$1 && !isMobile) {
            match$2 = Organism_Menu_Items_Utils.grow(linksWithWidth, linksMore, widthListItems, widthAvailable);
          } else {
            exit = 1;
          }
          if (exit === 1) {
            match$2 = Organism_Menu_Items_Utils.shrink(linksWithWidth, linksMore, widthListItems, widthAvailable);
          }
          var newLinksMore = match$2[1];
          var newLinksVisible = match$2[0];
          Curry._1(setLinksVisible, (function (param) {
                  return newLinksVisible;
                }));
          Curry._1(setLinksMore, (function (param) {
                  return newLinksMore;
                }));
          Curry._1(setLastWidthAvailable, (function (param) {
                  return screenSize$2;
                }));
        }));
  return React.createElement(React.Fragment, undefined, React.createElement(Atom_Box.make, {
                  background: view.background,
                  children: null,
                  direction: direction,
                  kind: /* List */5,
                  width: width,
                  ref_: refItems
                }, Belt_Array.map(linksVisible, (function (param) {
                        var id = param.id;
                        var isCurrent = Belt_Option.map(currentLinkId, (function (currentLinkId) {
                                return currentLinkId === id;
                              }));
                        var tmp = {
                          ariaLabel: param.ariaLabel,
                          id: id,
                          label: param.label,
                          subLinks: param.subLinks,
                          title: param.title,
                          highlight: param.highlight,
                          isCurrent: isCurrent,
                          view: view,
                          key: id
                        };
                        if (param.href !== undefined) {
                          tmp.href = Caml_option.valFromOption(param.href);
                        }
                        return React.createElement(Organism_Menu_Items$Link, tmp);
                      })), linksMore.length !== 0 ? React.createElement(Organism_Menu_Item_With_Childs.make, {
                        id: buttonMore.id,
                        label: buttonMore.label,
                        subLinks: Belt_Array.map(linksMore, Type_Organism_Menu.Internal.linkToSubLink),
                        view: view
                      }) : null, children));
}

var make = Organism_Menu_Items;

export {
  Link ,
  make ,
}
/* react Not a pure module */
